export default __webpack_public_path__ + "static/media/logo-rfe.770347b3.png";